import { render, staticRenderFns } from "./MreglaModals.vue?vue&type=template&id=223e7f5a"
import script from "./MreglaModals.vue?vue&type=script&lang=js"
export * from "./MreglaModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports